/**
 * BackgroundGeneratorView — placeholder for the background generator feature.
 */

export class BackgroundGeneratorView {
    constructor(app) {
        this.app = app;
    }

    activate() {
        document.getElementById('canvas-container').style.display = 'none';
        document.getElementById('background-generator').style.display = 'flex';
    }

    deactivate() {
        document.getElementById('background-generator').style.display = 'none';
        document.getElementById('canvas-container').style.display = '';
    }

    applyLayout() {}
}
